import { useTranslation } from 'react-i18next'

import Section from '../components/Section'

interface StorageRow {
  name: string
  type: string
  purpose: string
  when: string
}

interface TextSection {
  heading: string
  body: string[]
}

// Plain "heading + paragraphs" blocks, in document order. The storage table
// (2.) is rendered separately below since it isn't prose.
const BODY_KEYS = ['overview', 'fonts', 'maps', 'analytics', 'banner', 'manage'] as const

function CookiesPage() {
  const { t } = useTranslation()
  const rows = t('legal.cookies.storageRows', { returnObjects: true }) as StorageRow[]
  const th = t('legal.cookies.storageTh', { returnObjects: true }) as Record<
    string,
    string
  >

  const sections: TextSection[] = BODY_KEYS.map((key) => ({
    heading: t(`legal.cookies.${key}Heading`),
    body: t(`legal.cookies.${key}Body`, { returnObjects: true }) as string[],
  }))

  return (
    <div className="legal-page">
      <Section background="surface" space="md" className="legal-hero">
        <h1 className="display">{t('legal.cookies.title')}</h1>
        <p className="legal-updated">
          {t('legal.updatedLabel', { date: t('legal.lastUpdated') })}
        </p>
        <p className="legal-lead">{t('legal.cookies.intro')}</p>
      </Section>

      <Section background="beige" space="lg" className="legal-body">
        <article className="legal-article">
          <section>
            <h2>{sections[0].heading}</h2>
            {sections[0].body.map((para) => (
              <p key={para}>{para}</p>
            ))}
          </section>

          <section>
            <h2>{t('legal.cookies.storageHeading')}</h2>
            <div className="legal-table-wrap">
              <table className="legal-table">
                <thead>
                  <tr>
                    <th>{th.name}</th>
                    <th>{th.type}</th>
                    <th>{th.purpose}</th>
                    <th>{th.when}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.name}>
                      <td data-label={th.name}>{row.name}</td>
                      <td data-label={th.type}>{row.type}</td>
                      <td data-label={th.purpose}>{row.purpose}</td>
                      <td data-label={th.when}>{row.when}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {sections.slice(1).map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.body.map((para) => (
                <p key={para}>{para}</p>
              ))}
            </section>
          ))}
        </article>
      </Section>
    </div>
  )
}

export default CookiesPage
